// extracted by mini-css-extract-plugin
module.exports = {"weightAndRequired":"styles_weightAndRequired__2jHI4"};